import { Coord } from "../../../../../../../src/types/Interface";
import { ShapeAnswer } from "../../../types/Interface";
import { checkSameCoord } from "./checkSameCoord";


export default function checkLinesAnswer(qAnsLineCoords: Coord[][], answer: ShapeAnswer): boolean {
  if (qAnsLineCoords.length !== answer.answer.length) { return false }
  const uAnsLineCoords = [...answer.answer].map(c => c.coord);
  const ans = Array(qAnsLineCoords.length).fill(null).map((_, i) => {
    const line = [...qAnsLineCoords][i];
    const fLine = uAnsLineCoords
      .find(c => {
        return (checkSameCoord(c[0], line[0]) && checkSameCoord(c[1], line[1]))
          || (checkSameCoord(c[0], line[1]) && checkSameCoord(c[1], line[0]))
      });
    return Boolean(fLine);
  })
  return !ans.includes(false)
}